export default __webpack_public_path__ + "f8c55715022773f0859a4cf19b9a1085.png";